import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { verifyMagicLink } from '@/api/competitionApi';
import { PublicPageShell } from '@/components/layout/PageShell';
import { useCompetitionStore } from '@/store/competitionStore';

export const WeryfikacjaPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setVerification = useCompetitionStore((s) => s.setVerification);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');

    async function verify() {
      if (!token) {
        setError('Brak tokenu w adresie URL. Sprawdź czy link jest kompletny.');
        return;
      }

      try {
        const data = await verifyMagicLink(token);
        setVerification(
          data.serverNow,
          data.startTime,
          data.durationMs,
          data.savedAnswers,
          data.inProgress,
          data.stage,
        );
        navigate(data.inProgress ? '/turniej' : '/poczekalnia', { replace: true });
      } catch (err) {
        setError(
          err instanceof Error
            ? err.message
            : 'Nieprawidłowy lub wygasły link. Skontaktuj się z organizatorem.',
        );
      }
    }

    void verify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <PublicPageShell mainClassName="items-center justify-center px-4 py-8">
        <div className="w-full max-w-lg rounded-3xl bg-white/90 px-8 py-8 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <svg
              className="h-8 w-8 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2 className="mt-4 text-lg font-bold text-gray-800">Weryfikacja nie powiodła się</h2>
          <p className="mt-2 text-sm text-gray-500">{error}</p>
          <p className="mt-4 text-xs text-gray-400">
            Jeśli problem się powtarza, skontaktuj się z organizatorem turnieju.
          </p>
        </div>
      </PublicPageShell>
    );
  }

  return (
    <PublicPageShell mainClassName="items-center justify-center px-4 py-8">
      <div className="w-full max-w-lg rounded-3xl bg-white/90 px-8 py-10 text-center">
        <svg
          className="mx-auto h-14 w-14 animate-spin text-competition-accent"
          fill="none"
          viewBox="0 0 24 24"
          aria-label="Ładowanie..."
          role="status"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="3"
          />
          <path
            className="opacity-80"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
        <p className="mt-5 text-base font-medium text-gray-500">Weryfikacja uczestnika...</p>
      </div>
    </PublicPageShell>
  );
};
